/* eslint-disable max-len */
/* eslint-disable react/destructuring-assignment */
import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Input, Form, Button, Card, Col, Row, Popconfirm, notification, Modal,
} from 'antd';
import { editApplicationSurveyPostmonitoringRID } from '../../utils/http';


const { TextArea } = Input;
function SurveyRid({
  elementsArrayProp, applicationId, disabled, type,
}) {
  const [elementsArray, setElementsArray] = useState([]);
  const [objectInEditId, setObjectInEditId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const formRef = useRef(null);
  const [isFormDisabled, setIsFormDisabled] = useState(true);

  useEffect(() => {
    setElementsArray(elementsArrayProp);
    setIsFormDisabled(disabled);
  }, []);

  const onEditClick = (id) => setObjectInEditId(id);

  const onAddClick = () => {
    setLoading(true);
    const objToSave = { type };
    objToSave.applicationSurveyPostmonitoring_id = applicationId;
    editApplicationSurveyPostmonitoringRID(objToSave)
      .then((id) => {
        setObjectInEditId(id);
        const updatedArray = [...elementsArray, { id, type }];
        setElementsArray(updatedArray);
        setLoading(false);
        notification.success({ message: 'Сохранено!' });
      });
  };

  const onDeleteClick = (id) => {
    setLoading(true);
    editApplicationSurveyPostmonitoringRID({ id, isDeleted: true })
      .then(() => {
        setObjectInEditId(null);
        const updatedArray = elementsArray.filter((p) => p.id !== id);
        setElementsArray(updatedArray);
        setLoading(false);
        notification.success({ message: 'Сохранено!' });
      });
  };

  const onCancelClick = () => {
    const values = formRef.current.getFieldsValue();
    const valuesKeys = Object.keys(values);
    let isEmpty = true;
    valuesKeys.forEach((k) => {
      if (values[k]) {
        isEmpty = false;
      }
    });
    if (isEmpty) {
      onDeleteClick(objectInEditId);
    } else {
      setObjectInEditId(null);
    }
  };

  const onSaveClick = () => {
    const values = formRef.current.getFieldsValue();
    setLoading(true);
    editApplicationSurveyPostmonitoringRID({ id: objectInEditId, ...values, type })
      .then(() => {
        const updatedArray = elementsArray.map((p) => (p.id === objectInEditId ? {
          id: objectInEditId, ...values,
        } : p));
        setObjectInEditId(null);
        setElementsArray(updatedArray);
        setLoading(false);
        notification.success({ message: 'Сохранено!' });
      });
  };

  const onExpand = (id) => {
    setObjectInEditId(id);
    setIsExpanded(true);
    setIsFormDisabled(true);
  };

  const onCollapse = () => {
    setObjectInEditId(null);
    setIsExpanded(false);
    setIsFormDisabled(disabled);
  };

  return (
    <div style={{
      margin: '20px', padding: '20px', border: '1px solid #cdcdcd', borderRadius: '10px', display: 'flex', flexDirection: 'column',
    }}
    >
      {/* <span style={{ fontSize: '24px', color: '#212121' }}>Объекты</span> */}
      {elementsArray.map((p, i) => (
        <Card
          key={p.id}
          style={{ width: '100%', borderRadius: '5px', marginTop: '20px' }}
          bodyStyle={{
            borderLeft: objectInEditId === p.id ? '4px solid #1890FF' : '',
            borderRadius: objectInEditId === p.id ? '5px' : '',
          }}
        >
          <Col span={24}>
            <Row justify="space-between" align="middle">
              <Col>
                {p.task || `Объект №${i + 1}`}
              </Col>
              <Col>
                <Row align="middle" gutter={10}>
                  {!objectInEditId && (<Col><Button type="primary" onClick={() => onEditClick(p.id)} disabled={isFormDisabled}>Редактировать</Button></Col>)}
                  {!objectInEditId && (
                    <Col>
                      <Popconfirm
                        title="Уверены, что хотите удалить объект?"
                        onConfirm={() => onDeleteClick(p.id)}
                        okText="Да"
                        cancelText="Нет"
                      >
                        <Button type="danger" disabled={isFormDisabled}>Удалить</Button>
                      </Popconfirm>
                    </Col>
                  )}
                  {!objectInEditId && (<Col><Button onClick={() => onExpand(p.id)}>Показать</Button></Col>)}
                </Row>
              </Col>
            </Row>
            {objectInEditId === p.id
                && (
                  <Modal title="Редактирование объекта" visible footer={null} width="90vw" maskClosable={false} closable={false}>
                    <Form initialValues={{ remember: true }} ref={formRef} style={{ marginTop: '20px' }}>
                      <Col>
                        <Form.Item
                          name="type"
                          initialValue={type}
                          hidden
                        />
                        <div className="common-field-wrapper">
                          <span className="common-field-label">Наименование</span>
                          <Form.Item
                            name="name"
                            initialValue={p.name}
                          >
                            <TextArea autoSize disabled={isFormDisabled || loading} />
                          </Form.Item>
                        </div>
                        <div className="common-field-wrapper">
                          <span className="common-field-label">Номер</span>
                          <Form.Item
                            name="number"
                            initialValue={p.number}
                          >
                            <TextArea autoSize disabled={isFormDisabled || loading} />
                          </Form.Item>
                        </div>
                        <div className="common-field-wrapper">
                          <span className="common-field-label">Правообладатель</span>
                          <Form.Item
                            name="owner"
                            initialValue={p.owner}
                          >
                            <TextArea autoSize disabled={isFormDisabled || loading} />
                          </Form.Item>
                        </div>
                      </Col>
                    </Form>
                    <Row justify="end">
                      {objectInEditId === p.id && isExpanded && (<Col><Button type="primary" onClick={() => onCollapse()}>Закрыть</Button></Col>)}
                      {objectInEditId === p.id && !isExpanded && (<Col><Button type="primary" onClick={onSaveClick} disabled={isFormDisabled} style={{ marginRight: '10px' }}>Сохранить</Button></Col>)}
                      {objectInEditId === p.id && !isExpanded && (<Col><Button onClick={onCancelClick}>Отменить</Button></Col>)}
                    </Row>
                  </Modal>
                )}
          </Col>
        </Card>
      ))}
      {!objectInEditId && <Button type="primary" onClick={onAddClick} style={{ marginTop: '20px', width: '200px', fontSize: '16px' }} disabled={isFormDisabled}>Добавить объект</Button>}
    </div>
  );
}

SurveyRid.propTypes = {
  elementsArrayProp: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  applicationId: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired,
};

export default SurveyRid;
